import React from 'react';
import LearnosityText from '../LearnosityText';

const TEIDistractor = ({ text, className }) => (
  <LearnosityText className={className} text={text} />
);

TEIDistractor.propTypes = {};

export default TEIDistractor;
